import React, { Component } from "react";
import PropTypes from "prop-types";
import Tab from "./Tab";

class Tabs extends Component {
    static propTypes = {
        children: PropTypes.instanceOf(Array).isRequired,
    };

    constructor(props) {
        super(props);
        //let lastTab = localStorage.getItem('currentTab');
        let tab ;
        //let tab =  (lastTab !== null &&  lastTab !== '' &&  lastTab != undefined) ? lastTab : this.props.children[0].props.id;
        if(this.props && this.props.children && this.props.children[0])
        {
            tab =this.props.children[0].props.id;

        }
        this.state = {
            activeTab: tab,

        };
    }

    onClickTabItem = (tab) => {
        this.setState({ activeTab: tab });
        //localStorage.setItem('currentTab', tab);
    };

    render() {
        const {
            onClickTabItem,
            props: { children },
            state: { activeTab },
        } = this;

        return (
            <div className="card card-primary card-tabs">
                <div className="card-header p-0 pt-1">
                    <ol className="nav nav-tabs">
                        {children.map((child) => {

                            if(child && child.props )
                            {
                                const { id, label } = child.props;

                                return (
                                    <Tab
                                        activeTab={activeTab}
                                        key={id}
                                        id={id}
                                        label={label}
                                        onClick={onClickTabItem}
                                    />
                                );
                            }

                        })}
                    </ol>
                </div>
                <div className="card-body">
                    <div className="tab-content">
                        {children.map((child) => {
                            if (!child || !child.props  || child.props.id !== activeTab) return undefined;
                            return child.props.children;
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

export default Tabs;